import React from 'react';
import LeadCaptureForm from './LeadCaptureForm';
import { useLeadCapture } from '@/contexts/LeadCaptureContext';

const LeadCaptureModal: React.FC = () => {
  const { isOpen, closeLeadForm, formOptions } = useLeadCapture();

  return (
    <LeadCaptureForm
      isOpen={isOpen}
      onClose={closeLeadForm}
      onSuccess={formOptions.onSuccess}
      redirectToWhatsApp={formOptions.redirectToWhatsApp}
      whatsAppMessage={formOptions.whatsAppMessage}
    />
  );
};

export default LeadCaptureModal;
